import { render, staticRenderFns } from "./PopoverAddDomain.vue?vue&type=template&id=bb441a32&"
import script from "./PopoverAddDomain.vue?vue&type=script&lang=ts&"
export * from "./PopoverAddDomain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports